(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addDownload = function(customerId, productTitle, productImageUrl) {
    if (!customerId) return;
    const postData = {
      customer_id: customerId,
      file_url: productTitle,
      timestamp: new Date().toISOString().split('T')[0],
      image_url: productImageUrl,
      product_url: window.location.href
    };
    fetch('https://m.homedepotonline.ph/api/index2/addDownloadHistory', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData)
    }).then(r => console.log('Tracked'));
  }

  document.addEventListener('DOMContentLoaded', () => {
    // Only target ACTUAL <video> tags, not iframes or other elements
    const video = document.querySelector('video.snappi-native-video');
    if (video) {
        // Force play
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log("Autoplay prevented:", error);
            video.muted = true;
            video.play();
          });
        }

        // IG Reels Style: Click to toggle play/pause
        video.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
